import { useForm } from "react-hook-form";
import { CoberturaPoliza } from "../models/polizaSeguro";
import { Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useEffect } from "react";
import { useCobertura } from "../hooks/useCobertura";
import { StatusCode } from "../../../../utils/enums";
import { useToast } from "../../../../hooks/useToast";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";


interface ModalCoberturaProps {
    show: boolean;
    codigo: string;
    codigohijo?: string;
    isEditar?: boolean;
    coberturaEditar?: CoberturaPoliza;
    onHide: () => void;
    refresh: () => void;
}
const schema = yup.object({
    polizaCodigo: yup.string().required("El código de póliza es requerido"),
    polizaCodigohijo: yup.string().required(),
    codigoCobertura: yup.string().required("El código de cobertura es requerido"),
    tasa: yup.number().typeError("La tasa es requerida").required("La tasa es requerida").moreThan(0, "La tasa debe ser mayor o igual a 0").max(5, "La tasa no puede exceder 5 digitos"),
    prima: yup.number().required("La prima es requerida").moreThan(0, "La prima debe ser mayor o igual a 0").max(9, "La prima no puede exceder 9 digitos"),
}).required();

const ModalCobertura: React.FC<ModalCoberturaProps> = ({
    show,
    codigo,
    codigohijo,
    isEditar,
    coberturaEditar,
    onHide,
    refresh
}) => {
    const save = useCobertura();
    const { addToast } = useToast();

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
        watch,
    } = useForm<CoberturaPoliza>({
        mode: 'onChange',
        resolver: yupResolver(schema),

    });

    const dataForm = watch();

    useEffect(() => {
        if (show && isEditar && coberturaEditar) {
            setValue("polizaCodigo", codigo);
            setValue("polizaCodigohijo", codigohijo ?? "");
            setValue("codigoCobertura", coberturaEditar.codigoCobertura);
            setValue("tasa", coberturaEditar.tasa);
            setValue("prima", coberturaEditar.prima);
        } else if (show && !isEditar) {
            reset({
                polizaCodigo: codigo,
                polizaCodigohijo: codigohijo,
                codigoCobertura: "",
                tasa: 0,
                prima: 0
            });
        }
    }, [show, isEditar, coberturaEditar, codigo, codigohijo, setValue, reset]);

    const onSubmit = async (data: CoberturaPoliza) => {
        const response = await save(data, isEditar ? coberturaEditar : undefined);

        if (response.status === StatusCode.NoContent || response.status === StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: isEditar ?
                    'Cobertura modificada con éxito.' :
                    'Cobertura creada con éxito.'
            });
            
            refresh();
            customOnHide();
        }          
        
    };

    function customOnHide() {
        reset();
        onHide();
    }

    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {isEditar ? 'Editar cobertura' : 'Crear cobertura'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 container spacing={2} sx={{ mt: 1 }}>
                        <Grid2 size={4}>
                            <InputText
                                name="codigoCobertura"
                                control={control}
                                label='Código cobertura'
                                error={errors.codigoCobertura}
                                desabilitado={isEditar}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <InputNumber
                                name="tasa"
                                control={control}
                                label="Tasa"
                                decimales={4}
                                error={errors.tasa}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <InputNumber
                                name="prima"
                                control={control}
                                label="Prima"
                                decimales={4}
                                error={errors.prima}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                        <Grid2>
                            <MButton variant="contained" type="submit">
                                Guardar
                            </MButton>
                        </Grid2>
                        <Grid2>
                            <MButton variant="contained" color="inherit" onClick={customOnHide}>
                                Cancelar
                            </MButton>
                        </Grid2>
                    </Grid2>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ModalCobertura;